import { styled, css } from "styled-components";
import { createEditableProps } from "@ludens-reklame/rubics-v3-react/util/fns";
import {
  Constrainer,
  HorizontalSpacer,
  VerticalSpacer,
} from "../../internal-components/Layout.js";
import { RichText } from "../../internal-components/RichText.js";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { cssSpacing, surfaceColorMap } from "../../util/styles.js";
import {
  ButtonAction,
  ButtonActionProps,
} from "../../internal-components/Button.js";
import type { BackgroundColor } from "../../types/theme.js";

export interface Props {
  text?: string;
  actions?: ButtonActionProps[];
  background?: BackgroundColor;
}

export const CTA: React.FunctionComponent<Props> = ({ text, actions = [], background }) => {
  return (
    <VerticalSpacer>
      <HorizontalSpacer>
        <Constrainer $width="small">
          <Content $bg={background}>
            <RichText
              dangerouslySetInnerHTML={{ __html: text || "" }}
              {...createEditableProps("html", "text")}
            />
            {actions.length > 0 && (
              <Actions>
                {(actions.filter((x) => x.link) as ButtonActionProps[]).map(
                  (action, i) => (
                    <ButtonAction key={i} {...action} />
                  )
                )}
              </Actions>
            )}
          </Content>
        </Constrainer>
      </HorizontalSpacer>
    </VerticalSpacer>
  );
};

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${(props) => props.theme.spacing.m};
  margin-top: ${(props) => props.theme.spacing.m};
`;

export const Content = styled.div<{ $bg?: BackgroundColor }>`
  ${(props) =>
    props.$bg
      ? css`
          background-color: ${surfaceColorMap[props.$bg]};
          color: ${props.$bg === "surface3" ? "#fff" : "var(--swatch2)"};
          svg path {
            fill: currentColor;
            stroke: currentColor;
          }
        `
      : css`
          background-color: var(--cta-background);
          color: var(--cta-text-color);
        `}
  border-radius: ${(props) => props.theme.borderRadius};
  padding: ${cssSpacing("m", "l")};

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${cssSpacing("l", "xl")};
  }
`;
